import { Chip } from '@material-ui/core';
import { lighten, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { useContext } from 'react';
import { observer } from 'mobx-react';
import { DataGridFilterContext, getTotalActiveGridFilters } from './gridFilterState';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    clearChip: {
      height: 32,
      padding: theme.spacing(0, 0.5),
      fontWeight: 600,
      color: theme.palette.primary.main,
      backgroundColor: lighten(theme.palette.primary.main, 0.88),
      '& .MuiChip-icon': {
        color: theme.palette.primary.main,
        fontSize: 18,
      },
      '&:hover, &:focus': {
        backgroundColor: lighten(theme.palette.primary.main, 0.8),
      },
    },
  })
);

export interface FilterButtonProps {
  onClearFilters: () => void;
  /** @deprecated the filter row is always visible now; kept so existing callers compile */
  onToggleFilters?: () => void;
}

export interface IconFilterButtonProps {
  onClearFilters: () => void;
  /** @deprecated ignored; the filter row is always visible */
  onToggleFilters?: () => void;
  /** @deprecated ignored; the filter row is always visible */
  showFilters?: boolean;
}

/**
 * "Clear N filters" chip, shown only while the grid has active column filters.
 * Inside a DataGrid toolbar it reads that grid's filter count; elsewhere (e.g. a tab bar)
 * it uses the active filters of the mounted grids.
 */
export const FilterButton = observer((props: FilterButtonProps) => {
  const classes = useStyles();
  const gridFilterCount = useContext(DataGridFilterContext);
  const count = gridFilterCount ?? getTotalActiveGridFilters();

  if (!count) {
    return null;
  }

  return (
    <Chip
      className={classes.clearChip}
      size="small"
      clickable
      icon={<Close />}
      label={`Clear ${count} ${count === 1 ? 'filter' : 'filters'}`}
      onClick={() => props.onClearFilters()}
      data-testid="clear-filters"
    />
  );
});

/**
 * Kept for existing callers: now renders the same "Clear N filters" chip as FilterButton.
 * The filter row is always visible, so `onToggleFilters` / `showFilters` are ignored.
 */
export const IconFilterButton = (props: IconFilterButtonProps) => (
  <FilterButton onClearFilters={props.onClearFilters} />
);
